"use client";

import { useCallback } from "react";
import { GroqImage } from "@/helpers/Image";

export default function ExperienceCard({
  cardNumber,
  cardTitle,
  cardText,
  cardImg,
  cardImgMobile,
}: {
  cardNumber: number;
  cardTitle: string;
  cardText?: string;
  cardImg: any,
  cardImgMobile: any,
}) {
  const scrollTo = useCallback(
    (e: React.MouseEvent<HTMLDivElement>, cardNumber: number) => {
      e.preventDefault();
      const el = document.getElementById(`component-${cardNumber}`);

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    []
  );

  const colorsClasses =
    cardNumber === 1
      ? "text-[#FD6B17] experience-card-number-title-1"
      : cardNumber === 2
      ? "text-[#AC80FF] experience-card-number-title-2"
      : cardNumber === 3
      ? "text-[#5461E5] experience-card-number-title-3"
      : "text-[#17EEFD] experience-card-number-title-4";

  return (
    <div
      className={`${
        !cardText ? `mobile-experience-card-${cardNumber}` : `mobile-experience-card-${cardNumber}-text`
      } w-full h-full lg:w-auto rounded-[1rem] lg:relative flex flex-col gap-[2rem] transition duration-300 ease-in-out hover:scale-[1.01] cursor-pointer overflow-clip`}
      onClick={(e) => scrollTo(e, cardNumber)}
    >
      <div className="pl-[6rem] lg:pl-[4rem] pb-[4rem] lg:absolute lg:bottom-0 lg:left-0 block items-center lg:items-end justify-start gap-[2rem] order-2">
        <div className="flex lg:flex-col gap-[2rem] items-center lg:items-start">
          <span
            className={`${colorsClasses} experience-card-number-title min-w-[7rem] flex justify-center rounded-[1rem] py-[1rem] lg:py-[1.6rem] text-[2rem] lg:text-[3rem] font-[700] leading-[130%] tracking-[-0.210rem] h-min`}
          >
            0{cardNumber}
          </span>
          <h4
            className={
              cardText
                ? "gradient-title text-[3rem] lg:text-[2.5rem] font-[700] leading-[130%] tracking-[-0.210rem] lg:pt-[2rem]"
                : "gradient-title text-[3rem] font-[700] leading-[130%] tracking-[-0.210rem] lg:pt-[2rem]"
            }
            dangerouslySetInnerHTML={{
              __html: cardTitle,
            }}
          ></h4>
        </div>
        {cardText && (
          <>
            <p className="sans text-[2rem] font-[400] leading-[150%] text-[#DADADA] opacity-75 mt-[1rem] lg:hidden mb-0">
              {cardText.replace("<br/>", "")}
            </p>
            <p
              className="sans text-[2rem] font-[400] leading-[150%] text-[#DADADA] opacity-75 mt-[1rem] hidden lg:block mb-0"
              dangerouslySetInnerHTML={{
                __html: cardText,
              }}
            ></p>
          </>
        )}
      </div>
      {/* DESKTOP */}
      <GroqImage
        src={cardImg}
        alt={`Card ${cardNumber}`}
        className={
          cardNumber === 1 || cardNumber === 4
            ? "h-full hidden lg:block lg:!max-w-[102rem]"
            : "h-full hidden lg:block lg:!max-w-[80rem]"
        }
      />
      {/* MOBILE */}
      <GroqImage
        src={cardImgMobile}
        alt={`Card ${cardNumber}`}
        className="!w-full !h-full order-1 lg:hidden"
      />
    </div>
  );
}
